import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance_my_team_reportee_employee = get_axios_instance(api_variables.SERVICE_MY_TEAM_GET);

//const _pk_name = "id";

const state = {
  data:{},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },
  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.data = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("Direct Reportee Data! ",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_my_team_reportee_employee.get(``, {
        params: {
            employee_id: payload.employee_id,
        }
      });
      commit("setFetching", false);
      //console.log("Direct Reportee Dataaa....! ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("set", res.data.rows);
      return res;
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

}

export default {
  namespaced: true,
  state, mutations, actions
}
// export default {
//     namespaced: true,
//     modules: {}
// }